import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';

import initMenu from './components/menu';
import initCookies from './components/cookies';

import initHomeHero from './components/home/hero.js';
import initFadeImages from './components/fade-images.js';
import initTalentFilter from './components/talent-filter.js';
import initOverlay from './components/overlay.js';
import initSliders from './components/sliders.js';
import initHideMenu from './components/hide-menu.js';
import initStatements from './components/statements.js';
import initNewsLink from './components/news-link.js';

// initCookies();

initHideMenu();

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-menu');

if (menuEl) {
    initMenu(menuEl);
}

// Home hero
const homeHero = document.querySelector('.js-home-hero');

if (homeHero) {
    initHomeHero(homeHero);
}

// Fade images
const fadeImages = document.querySelectorAll('.js-fade-image');

if (fadeImages && fadeImages.length > 0) {
    initFadeImages(fadeImages);
}

// Overlay 
const overlayTriggers = document.querySelectorAll('.js-overlay-trigger');

if (overlayTriggers && overlayTriggers.length > 0) {
    initOverlay(overlayTriggers);
}

// Talent filter
const talentFilter = document.querySelector('.js-filter');

if (talentFilter) {
    initTalentFilter(talentFilter);
}

// Sliders
const sliders = document.querySelectorAll('.js-slider');

if (sliders && sliders.length > 0) {
    initSliders(sliders);
}


// Statements
const statements = document.querySelectorAll('.js-statement');

if (statements && statements.length > 0) {
    initStatements(statements);
}

// Statements
const newsLink = document.querySelector('.js-news-link');

if (newsLink) {
    initNewsLink(newsLink);
}
